import { render, staticRenderFns } from "./CustomerFormTab.vue?vue&type=template&id=4994d988"
import script from "./CustomerFormTab.vue?vue&type=script&lang=js"
export * from "./CustomerFormTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports